import React, { Component } from 'react'
import { Button, Col, Nav, Navbar, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import {
  emitPostData,
  formatCurrency,
  getRemainingTime,
  getUrlParamQueries,
  millisToMinutesAndSeconds,
  padNum,
  windowResize
} from '../../utils'
import { $t } from '../../utils/translate'
import { getMessages } from '../../actions/messageActions'
import { getBalance } from '../../actions/balanceActions'
import { connect } from 'react-redux'
import IntroBox from '../MessageBox/intro';
class BetBar extends Component {
  _isMounted = false

  constructor(props) {
    super(props)
    this.props = props
    this.state = {
      timeRemain: '',
      activeNav: 'home',
      balance: 0,
      infoMessage:false,
      modalShow: (window.introbox == undefined)
    }
  }

  componentDidUpdate(prevProps, prevState) {

    if (this.props.balance !== prevProps.balance) {
      if (typeof this.props.balance != "undefined") {
        if (this.props.balance.length > 0) {
          this.setState({ balance: this.props.balance[0].balance })
        }
      }
    }
    windowResize()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  componentDidMount = () => {

    this._isMounted = true
    this.props.getBalance()

    if (this.props.messages.length === 0) {
      this.props.getMessages()
    }
    setTimeout(() => {
      if (this.props.endings != '') {
        this.runTimer()
      }
    }, 100)
    setInterval(() => {
      if (this.props.endings != '') {
        this.runTimer()
      }
    }, 1000)

    if (this.props.balance != "") {
      this.setState({infoMessage:true});
    }

    if(typeof this.props.balance == 'undefined'){
      this.setState({infoMessage:true});
    }

    // setTimeout(()=>{ 
    //     this.setState({infoMessage:true});
    // },3000);

    let currentPath = window.location.pathname
    if (currentPath.indexOf("/how-to-play") === 0) {
      this.setState({ activeNav: "help" })
    } else if (currentPath.indexOf("/bet-history") === 0
      || currentPath.indexOf("/bet-settled-history") === 0) {
      this.setState({ activeNav: "bets" })
    } else if (currentPath.indexOf("/balance-history") === 0) {
      this.setState({ activeNav: "balance" })
    } else if (currentPath.indexOf("/prizes") === 0) {
      this.setState({ activeNav: "prizes" })
    } else if (currentPath.indexOf("/terms-and-conditions") === 0) {
      this.setState({ activeNav: "terms" })
    } else {
      this.setState({ activeNav: "home" })
    }
  }

  runTimer() {
    if (this._isMounted) {
      this.setState({ timeRemain: millisToMinutesAndSeconds(getRemainingTime(this.props.endings[this.props.jackpot.name])) })
    }
  }

  activateNav(value) {
    this.setState({ activeNav: value })
  }

  handleLogin() {
    emitPostData('events', { 'bettingLoginRequest': '' })
  }

  
  setModalShow(show) {
    this.setState({ modalShow: show }, () => {
        window.introbox = true;
        var html = document.documentElement;
        var doc_height = html.offsetHeight;
        if (doc_height < 500) {
            windowResize(500 - doc_height);
        }
        if (show) {
            let element = document.getElementsByClassName("modal-message")[0];
            document.documentElement.scrollTop = document.body.scrollTop = element.scrollTop;
        }
    });
}


  render() {
    let balance = '';

      if(typeof this.props.balance !== "undefined"){
        if(this.props.balance.length > 0){
            balance = this.props.balance[0].balance;
        }
      } 
      if(getUrlParamQueries()['loggedIn'] == 'false'){
        balance=0;
      }

    return (
      <div>
        {balance!=='' && 
         <IntroBox balance={balance!==''?padNum(balance):''} show={this.state.modalShow} onHide={() => this.setModalShow(false)} />
        }
        <div>
          <Row className="border betbar mx-0 no-gutters">
            <Col xs="12">
              <div className="nav-class bg-default p-0">
                <Navbar bg="default" variant="dark">
                  <Nav>
                    <Link
                      onClick={() => {
                        this.activateNav('home')
                      }}
                      className={this.state.activeNav == 'home' ? " active-link footer-link " : " footer-link "}
                      to={{ ...location, pathname: "/" }}>
                      <span className="d-none d-md-block">{$t('header_home', 'default', this.props.messages)}</span>
                      <img className="d-sm-block d-md-none" src="/assets/icons/icon_home.svg" alt="Home" width={32} />
                    </Link>
                    <Link
                      onClick={() => {
                        this.activateNav('bets')
                      }}
                      className={this.state.activeNav == 'bets' ? " active-link footer-link " : " footer-link "}
                      to={{ ...location, pathname: "/bet-history" }}>
                      <span>My Jackpots</span>
                    </Link>
                    <Link
                      onClick={() => {
                        this.activateNav('balance')
                      }}
                      className={this.state.activeNav == 'balance' ? " active-link footer-link " : " footer-link "}
                      to={{ ...location, pathname: "/balance-history" }}>
                      {/*<span>{$t('header_balance_history', 'default', this.props.messages)}</span>*/}
                      <span>My Tickets</span>
                    </Link>
                    <Link
                      onClick={() => {
                        this.activateNav('help')
                      }}
                      className={this.state.activeNav === 'help' ? " active-link footer-link " : " footer-link "}
                      to={{ ...location, pathname: "/how-to-play" }}>
                      {/*<span>{$t('header_how_to_play', 'default', this.props.messages)}</span>*/}
                      <span>How to enter</span>
                    </Link>
                    <Link
                      onClick={() => {
                        this.activateNav('prizes')
                      }}
                      className={this.state.activeNav === 'prizes' ? " active-link footer-link " : " footer-link "}
                      to={{ ...location, pathname: "/prizes" }}>
                      {/*<span>{$t('header_how_to_play', 'default', this.props.messages)}</span>*/}
                      <span>Prizes</span>
                    </Link>
                    <Link
                      onClick={() => {
                        this.activateNav('terms')
                      }}
                      className={this.state.activeNav === 'terms' ? " active-link footer-link " : " footer-link "}
                      to={{ ...location, pathname: "/terms-and-conditions" }}>
                      {/*<span>{$t('header_how_to_play', 'default', this.props.messages)}</span>*/}
                      <span>Terms and Conditions</span>
                    </Link>
                  </Nav>
                </Navbar>
              </div>
            </Col>
          </Row>
        </div>

        {(typeof this.props.balance == 'undefined' || this.props.balance != "") && (getUrlParamQueries()['loggedIn'] == 'false' || (((balance!=''?Number(balance):'') == 0) && getUrlParamQueries()['loggedIn'] != 'false')) &&
        <Row className="mx-0 my-2 message-bar no-gutters">

          <Col xs="12" md="10">
            <img src="/assets/info.svg"/>
            {getUrlParamQueries()['loggedIn'] == 'false' &&
            <span>
              {/* You do not have a ticket to enter this jackpot, please place any sports or Jika bet to enter */}
              {$t('body_text_login', 'default', this.props.messages)}
              </span>
            }

            {((balance!=''?Number(balance):'') == 0) && getUrlParamQueries()['loggedIn'] != 'false' &&
            
            <span>
              {/* {$t('body_text_zero_balance', 'default', this.props.messages)} */}
              You do not have a ticket to enter this jackpot, please place any sports bet to enter
              </span>
            }
          </Col>

          <Col xs="12" md="2">
            {getUrlParamQueries()['loggedIn'] == 'false' &&
            <Button onClick={() => {
              this.handleLogin()
            }}
                    className="btn-message-bar w-100 text-white btn-info btn-general">{$t('text_login', 'default', this.props.messages)}</Button>
            }

            {getUrlParamQueries()['hasToken'] == 'false' &&
            <a href="https://www.betway.co.za/sport" target="_parent"
               className="btn btn-message-bar w-100 text-white btn-info btn-general">{$t('text_bet_now', 'default', this.props.messages)}</a>
            }
          </Col>
        </Row>
        }
        {(this.props.gamesList != '' && Object.keys(this.props.gamesList).length > 0 && this.state.activeNav == 'home') &&
        <div>
          <Row noGutters className="competition-info">
            <Col xs="4" md={3}>
              {/* <div className="input-group my-2">
                <div className="input-group-prepend">
                  <span className="input-group-text">AVAILABLE TICKETS:</span>
                </div>
                <input type="text" disabled className="form-control" value={balance!=''?padNum(balance):'0'}/>
              </div> */}
            </Col>
            <Col xs="4" md={3}>
              {/* <div className="input-group my-2">
                <div className="input-group-prepend">
                  <span className="input-group-text">JACKPOT PRIZE:</span>
                </div>
                <input type="text" disabled className="form-control"
                       value={formatCurrency(this.props.gamesList[this.props.jackpot.name][0]['jackpot'])}/>
              </div> */}
            </Col>
            {/*
            // <Col md={{ span: 4, offset: 2 }} xs={{ span: 4, offset: 0 }}>
            //   <Row className="no-gutters my-2">
            //     <Col md="4" >
            //       <input type="text" disabled className="form-control " value={this.state.timeRemain}/>
            //     </Col>
            //     // <Col md="8" className="py-1 px-3">
            //     //   Until today's jackpot closes
            //     // </Col>
            //   </Row>
            // </Col>
          */}
          </Row>
          <h4 className="choose-text">CHOOSE ONE OUTCOME FROM EACH OF THE FIXTURES BELOW</h4>
        </div>
        }
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    gamesList: state.eventsReducer.gamesList,
    endings: state.eventsReducer.endings,
    messages: state.messageReducer.messages,
    balance: state.balanceReducer.balance
  }
}

export default connect(mapStateToProps, { getMessages, getBalance })(BetBar)



// WEBPACK FOOTER //
// ./components/BetBar/index.js